import { useEffect, useState } from "react";
import { isIOS, isMacOs } from "react-device-detect";
import {
  Overlay,
  Content,
  CloseButton,
  StoreLink,
} from "./PenchartGuideModal.styled";

// 태블릿으로 판단할 최소 너비(px). uno-crm-rn(use-device-check.ts)과 동일 기준
const TABLET_MIN_WIDTH = 600;

export const AOS_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.unocare.newunocrm";
export const IOS_STORE_LINK =
  "https://apps.apple.com/us/app/uno-crm-%ED%8E%9C%EC%B0%A8%ED%8A%B8/id6761960621";

export const PenchartGuideModal = ({ onClose }: { onClose: () => void }) => {
  // 폼팩터(UA) 대신 화면 너비로 판별 → 모바일 웹뷰 등 좁은 화면까지 대응
  // 가로/세로 무관하게 일관되도록 화면의 짧은 변을 기준으로 한다
  const getIsTablet = () =>
    Math.min(window.innerWidth, window.innerHeight) >= TABLET_MIN_WIDTH;

  const [isTablet, setIsTablet] = useState(getIsTablet);

  // 회전·창 크기 변경 시 태블릿/모바일 구분 갱신
  useEffect(() => {
    const handleResize = () => setIsTablet(getIsTablet());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 애플 OS(아이폰/아이패드/맥)는 브라우저 무관하게 App Store로 안내
  // iPadOS가 데스크탑 UA로 위장해도 isMacOs로 함께 잡힘
  const isIos = isIOS || isMacOs;

  const os = isIos ? "ios" : "aos";
  const device = isTablet ? "tablet" : "mobile";
  const storeLink = isIos ? IOS_STORE_LINK : AOS_STORE_LINK;
  const imageSrc = `/assets/images/guides/penchart-guide-${os}-${device}.png`;

  return (
    <Overlay onClick={onClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose} aria-label="닫기" />
        <img src={imageSrc} alt="펜차트 앱 가이드" />
        <StoreLink
          device={device}
          href={storeLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="앱 다운로드"
        />
      </Content>
    </Overlay>
  );
};
